module.exports = __webpack_public_path__ + "media/images/member-database-2-1-15b16d69a808223d0eba30031ac894c0.png";